import { useColorMode } from '@chakra-ui/react'
import { useEffect } from 'react'
import { Auth0Provider } from '@auth0/auth0-react'
import './app.css'
import { UserProvider } from '@ocean/shared/contexts/UserContext'
import { PresenceProvider } from '@ocean/shared/contexts/PresenceContext'
import { Router } from '@ocean/shared/router/Router'
import { useBulkJobAutoResume } from '@ocean/shared/hooks/useBulkJobAutoResume'
import { HotkeyBlockProvider } from '@ocean/shared/hooks/useHotkeyBlock'
import { HashRouter } from 'react-router-dom'

const AppShell = () => {
  const { colorMode, toggleColorMode } = useColorMode()
  useEffect(() => {
    if (colorMode === 'dark') toggleColorMode()
  }, [colorMode, toggleColorMode])

  // Auto-resume interrupted bulk jobs globally
  useBulkJobAutoResume()

  return (
    <HotkeyBlockProvider>
      <UserProvider>
        <PresenceProvider>
          <HashRouter>
            <Router />
          </HashRouter>
        </PresenceProvider>
      </UserProvider>
    </HotkeyBlockProvider>
  )
}

const App = () => {
  const onRedirectCallback = (appState?: { returnTo?: string }) => {
    sessionStorage.removeItem('logging_out')
    const returnTo = appState?.returnTo ?? '/react/dashboard'
    const normalizedReturnTo = returnTo.startsWith('/') ? returnTo : `/${returnTo}`
    window.history.replaceState({}, '', globalThis.location.origin + globalThis.location.hash)
    globalThis.location.hash = normalizedReturnTo
  }

  return (
    <Auth0Provider
      domain={import.meta.env.VITE_AUTH0_DOMAIN}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
      cacheLocation="localstorage"
      useRefreshTokens
      authorizationParams={{
        redirect_uri: globalThis.location.origin,
        audience: import.meta.env.VITE_AUTH0_AUDIENCE,
        scope: 'openid profile email offline_access',
      }}
      onRedirectCallback={onRedirectCallback}
    >
      <AppShell />
    </Auth0Provider>
  )
}

export default App
